import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../config';
import axios from 'axios';
import '../AdminSystem/ShowUser.css';
import Sidebar from './SideBar';

const ITEMS_PER_PAGE = 10;

const LoginLogsTable = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Search states
  const [searchEmail, setSearchEmail] = useState('');
  const [searchIP, setSearchIP] = useState('');
  const [searchDate, setSearchDate] = useState('');

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/log/`);
        setLogs(response.data);
        setFilteredLogs(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load login logs');
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  useEffect(() => {
    const filtered = logs.filter(log => {
      const matchesEmail = log.email.toLowerCase().includes(searchEmail.toLowerCase());
      const matchesIP = log.ipAddress?.toLowerCase().includes(searchIP.toLowerCase());
      const matchesDate = searchDate
        ? new Date(log.timestamp).toISOString().slice(0, 10) === searchDate
        : true;

      return matchesEmail && matchesIP && matchesDate;
    });

    setFilteredLogs(filtered);
    setCurrentPage(1);
  }, [searchEmail, searchIP, searchDate, logs]);

  // Pagination logic
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLogs.length / ITEMS_PER_PAGE);

  return (
    <div className="table-container-admin">
      <div className="sidebar-container">
        <Sidebar />
      </div>
      <h2>Login Logs</h2>

      {/* 🔍 Search Inputs */}
      <div className="search-boxes">
        <input
          type="text"
          placeholder="Search by email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
        />
        <input
          type="text"
          placeholder="Search by IP address"
          value={searchIP}
          onChange={(e) => setSearchIP(e.target.value)}
        />
        <input
          type="date"
          value={searchDate}
          onChange={(e) => setSearchDate(e.target.value)}
        />
      </div>

      {loading && <p>Loading logs...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {!loading && !error && (
        <>
          <div className="overflow-x-auto">
            <table className="admins-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Status</th>
                  <th>IP Address</th>
                  <th>User Agent</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((log) => (
                    <tr key={log._id}>
                      <td>{log.email}</td>
                      <td
                        style={{
                          color: log.status === 'SUCCESS' ? 'green' : 'red',
                          fontWeight: 'bold',
                        }}
                      >
                        {log.status}
                      </td>
                      <td>{log.ipAddress || '-'}</td>
                      <td className="truncate">{log.userAgent || '-'}</td>
                      <td>{new Date(log.timestamp).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>
                      No logs found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => prev - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LoginLogsTable;
